export default __webpack_public_path__ + "b24aac42ccc2b1c3fb48fefe0cfb803f.png";